import { useAuth } from '@/context/AuthContext';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { EMPTY_ID_ROLE, PAGE_BY_ROLE } from '@/constants/roles';
import { Loading } from '@/components/loading';
import { useUserAccessControl } from '@/context/UserAccessControl';

export const Route = createFileRoute('/')({
  component: RootRedirect,
});

function RootRedirect() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();
  const { currentRole, isLoading: isUserAccessLoading } = useUserAccessControl();
  const isReadyToRedirect = !isLoading && !isUserAccessLoading && isAuthenticated;

  const roleId = currentRole?.id || EMPTY_ID_ROLE;
  const targetRoute = PAGE_BY_ROLE[roleId as keyof typeof PAGE_BY_ROLE];

  useEffect(() => {
    if (!isReadyToRedirect) {
      return;
    }

    navigate({ to: targetRoute });
  }, [isReadyToRedirect, targetRoute, navigate]);

  return (
    <div className="flex flex-col h-screen items-center justify-center">
      <Loading message="Redirigiendo..." />
    </div>
  );
}

